import { gql } from "@apollo/client";

export const GET_SINGLE_ACTIVITY = gql`
  query GetSingleActivity($id: Int!) {
    voiceMessage(id: $id) {
      id
      title
      templateLink
      feature
      focus
      difficulty
      cognitiveDomains
      inLibrary
      createdOn
      deletedAt
      recordedBy {
        id
      }
      deactivationNote
      audioFile {
        id
        durationInSeconds
        filename
        downloadUrl
      }
    }
  }
`;

export const UPDATE_VOICE_MESSAGE = gql`
  mutation UpdateVoiceMessage(
    $id: Int!
    $title: String!
    $templateLink: String
    $feature: String
    $focus: String
    $inLibrary: Boolean
    $recordedById: Int!
    $cognitiveDomains: [String!]
    $difficulty: DifficultyType
  ) {
    updateVoiceMessage(
      id: $id
      data: {
        title: $title
        templateLink: $templateLink
        feature: $feature
        focus: $focus
        inLibrary: $inLibrary
        recordedById: $recordedById
        cognitiveDomains: $cognitiveDomains
        difficulty: $difficulty
      }
    ) {
      id
      title
      templateLink
      feature
      focus
      cognitiveDomains
      difficulty
      createdOn
      recordedBy {
        id
      }
      audioFile {
        id
        durationInSeconds
        filename
      }
    }
  }
`;

export const SET_VOICE_MESSAGE_ACTIVATION = gql`
  mutation SetVoiceMessageActivation($id: Int!, $isActive: Boolean!, $deactivationNote: String) {
    setVoiceMessageActivation(
      id: $id
      isActive: $isActive
      deactivateDto: { deactivationNote: $deactivationNote }
    ) {
      id
      deletedAt
      createdOn
      recordedBy {
        id
      }
      audioFile {
        durationInSeconds
        filename
      }
    }
  }
`;
